export class Country {
  shorthand: string;
  country: string;
  ddd: string;
  shorthandDdd: string;
  flag: string;
  mask: string;
  minPhoneSize: number;
  placeHolder: string;
}

export const countriesList: Country[] = [
  {
    shorthand: 'BR',
    country: 'Brasil',
    ddd: '+55',
    shorthandDdd: '55',
    flag: 'assets/flags/brazil.svg',
    mask: '(00) 00000-0000',
    minPhoneSize: 11,
    placeHolder: '(00) 00000-0000'
  },
  {
    shorthand: 'EUA',
    country: 'Estados Unidos',
    ddd: '+1',
    shorthandDdd: '1',
    flag: 'assets/flags/eua.svg',
    mask: '(000) 000-0000',
    minPhoneSize: 10,
    placeHolder: '(000) 000-0000'
  },
  {
    shorthand: 'URU',
    country: 'Uruguai',
    ddd: '+598',
    shorthandDdd: '598',
    flag: 'assets/flags/uruguay.svg',
    mask: '00000000',
    minPhoneSize: 8,
    placeHolder: '00000000'
  },
  {
    shorthand: 'POR',
    country: 'Portugal',
    ddd: '+351',
    shorthandDdd: '351',
    flag: 'assets/flags/portugal.svg',
    mask: '000 000 000',
    minPhoneSize: 9,
    placeHolder: '000 000 000'
  },
  {
    shorthand: 'PAR',
    country: 'Paraguai',
    ddd: '+595',
    shorthandDdd: '595',
    flag: 'assets/flags/paraguay.svg',
    mask: '(00) 000-0000',
    minPhoneSize: 7,
    placeHolder: '(00) 000-0000'
  },
  {
    shorthand: 'ARG',
    country: 'Argentina',
    ddd: '+54',
    shorthandDdd: '54',
    flag: 'assets/flags/argentina.svg',
    mask: '(000) 0000-0000',
    minPhoneSize: 6,
    placeHolder: '(000) 0000-0000'
  },
  {
    shorthand: 'ANG',
    country: 'Angola',
    ddd: '+244',
    shorthandDdd: '244',
    flag: 'assets/flags/angola.svg',
    mask: '000 000 000',
    minPhoneSize: 6,
    placeHolder: '000 000 000'
  }
];